import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { countriesOptions } from '@/locale';
import {
  inputRegex, optionalFieldWithRegex, requiredFieldWithRegex, errorMessages
} from '@/reusableInputConfig/reusableInputConfig';

interface FormField {
  label: string;
  id: string;
  type: string;
  options?: { value: string; displayValue: string }[];
}

type FormFields = Record<string, FormField>;

export interface ShippingFormData {
  childName?: string;
  country: string;
  address1: string;
  address2?: string;
  address3?: string;
  town: string;
  postcode: string;
}

export const formFields: FormFields = {
  childName: {
    label: 'Child\'s name',
    id: 'childName',
    type: 'text',
  },
  country: {
    label: 'Country',
    id: 'country',
    options: countriesOptions,
    type: 'select',
  },
  address1: {
    label: 'Address line 1',
    id: 'address1',
    type: 'text',
  },
  address2: {
    label: 'Address line 2',
    id: 'address2',
    type: 'text',
  },
  address3: {
    label: 'Address line 3',
    id: 'address3',
    type: 'text',
  },
  town: {
    label: 'Town or city',
    id: 'town',
    type: 'text',
  },
  postcode: {
    label: 'Postcode',
    id: 'postcode',
    type: 'text',
  },
};

export const getFormSchema = () => yup.object({
  childName: optionalFieldWithRegex(inputRegex.NAME.PATTERN, inputRegex.NAME.ERROR),
  country: yup.string().required(errorMessages.country),
  address1: requiredFieldWithRegex(inputRegex.ADDRESS.PATTERN, inputRegex.ADDRESS.ERROR, errorMessages.address1),
  address2: optionalFieldWithRegex(inputRegex.ADDRESS.PATTERN, inputRegex.ADDRESS.ERROR),
  address3: optionalFieldWithRegex(inputRegex.ADDRESS.PATTERN, inputRegex.ADDRESS.ERROR),
  town: requiredFieldWithRegex(inputRegex.ADDRESS.PATTERN, inputRegex.ADDRESS.ERROR, errorMessages.town),
  postcode: yup.string()
    .required(errorMessages.postcode.uk)
    .when('country', {
      is: 'GB',
      then: schema => schema
        .matches(
          inputRegex.UK_POSTCODE.PATTERN,
          inputRegex.UK_POSTCODE.ERROR
        ),
      otherwise: schema => schema
        .matches(
          inputRegex.NON_UK_POSTCODE.PATTERN,
          inputRegex.NON_UK_POSTCODE.ERROR
        ),
    }),
});

export const getFormResolver = () => yupResolver(getFormSchema());
